<template>
<el-dialog
  :visible='true'
  title='提示'
  :before-close='handleClose'
  width='600px'
  :close-on-click-modal='false'
>
  <div >
    <div>您好，您本次购买的增值服务包有效期为{{item.cycle}}天</div>
    <br/>
    <div>但您的软件将于{{this.invalidateDate}}到期，软件到期后，本次购买的增值服务包内容也将无法使用，为了不影响您的使用，购买服务包后，请及时给软件续费哦！</div>
  </div>
  <template #footer>
    <div class='dialog-bottom'>
      <el-button @click='handleClose' type='secondary' size='small'>取消</el-button>
      <el-button @click='handleConfirm' type='primary' size='small'>确定</el-button>
    </div>
  </template>
</el-dialog>
</template>

<script>

export default {
 name: '' ,
 components: {},
 props:{
  visible: {
    type: Boolean,
    default: false,
  },
  item:{
    type: Object,
    default:()=>{
      return {

      }
    },
  }
 },
 data() {
 return {
 
 }
 },
 computed: {},
 created() {
 
 },
 mounted() {
 
 },
 computed: {
  invalidateDate() {
    var invalidateDate = this.$store.getters.loginUserInfo.standardInvalidateDate;
      if (invalidateDate) {
        invalidateDate = invalidateDate.substr(0, 10);
      }
      return invalidateDate;
  },
 },

 methods: {
  handleClose() {
   this.$emit('close');
  },
  handleConfirm() {
   this.$emit('confirm');
  },
  
 }
}
</script>
<style lang='scss' scoped>

.dialog-bottom {
  text-align: right;
}
</style>